export default function DataTypes() {
    return (
        <div className={"blog-body"}>
            <h2>Data Types</h2>
            <p>
                Plural form of Latin word "datum", data, basically means information, information to
                observe and make analyzes from. From data science aspect, there are two data types.
                <ul>
                    <li><b>Numerical:</b> Data represented by values. Can either be discrete or continuous.</li>
                    <li><b>Categorical:</b> Data grouped into categories. Can be nominal or ordinal.</li>
                </ul>
                With advancement in technology, collecting and processing data become easier. Increments in data
                sizes
                and ability to use different data sources separated our understanding
                of data into two.
            </p>

                <h3>Traditional Data</h3>
            <p>
                Data that yields a tabular format, therefore each entry is distinct and can be gathered
                independently, meaning structured are called traditional data. It is very easy to manipulate
                traditional data to with software like Excel or languages like SQL or Python using
                pandas library. These manipulations are needed for cleansing. <br/>
                Big data distinguishes from traditional data along with some of its properties.
            </p>

                <h3>Big Data</h3>
            <p>
                The name "big" here leads to a misunderstanding, just being big in volume does not necessarily
                mean
                that data is a big data, it is about the management as well. Big data has
                five characteristic components, also known as 5V's of big data (vartika02, 2019).

                <ul>
                    <li><b>Volume:</b> This characteristic refers to size of the data. Big data is enormous,
                        requires
                        immense storage space.
                    </li>
                    <li><b>Velocity:</b> Big data is gathered continuously. Countless entries take place in the data
                        sets every fraction of time.
                    </li>
                    <li><b>Variety:</b> Big data can be structured, semi-structured or unstructured.</li>
                    <li><b>Veracity:</b> Working with a pile that huge can lead into confusing situations.</li>
                    <li><b>Value:</b> Data means nothing unless it get modified into something useful.</li>
                </ul>

                <p>
                    Big data is separated from traditional data because traditional techniques remains
                    insufficient, specially designed tools are required. Data sources can be literally anything:
                    numbers, text, images, videos, audio files etc. Like traditional data, big data also needs to
                    be cleansed. Table 1 shown below demonstrates some of the differences between traditional
                    and big data (Rajendran, Asbern, Kumar, Rajesh, & Abhilash, 2016).
                </p>

                <center>
                    <table>
                        <thead>
                        <tr>
                            <th>Traditional Data</th>
                            <th>Big Data</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Structured</td>
                            <td>Structured, semi-structured or unstructured</td>
                        </tr>
                        <tr>
                            <td>Small sized</td>
                            <td>Needs a lot of storage space</td>
                        </tr>
                        <tr>
                            <td>Easy to worh with</td>
                            <td>Difficult to manipulate</td>
                        </tr>
                        <tr>
                            <td>Average hardware requirements</td>
                            <td>Needs high-end hardware</td>
                        </tr>
                        <tr>
                            <td>Traditional tools are enough</td>
                            <td>Specialized tools are needed</td>
                        </tr>
                        </tbody>
                    </table>
                    <b>Table 1:</b> Differences between traditional and big data.
                </center>
                
            </p>
        </div>
    );
}